module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "scrollContainer",
    staticClass: "content"
  }, [_c('div', {
    staticClass: "account-ds"
  }, [_c('div', {
    staticClass: "bar bar-nav account-top-m"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": "/customer/account/index"
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("message.product_review")))])], 1)]), _vm._v(" "), (_vm.errormsg) ? _c('div', {
    staticClass: "fecshop_message"
  }, [_c('div', {
    staticClass: "error-msg"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.errormsg) + "\n                ")])])]) : _vm._e(), _vm._v(" "), (_vm.correctmsg) ? _c('div', {
    staticClass: "fecshop_message"
  }, [_c('div', {
    staticClass: "correct-msg"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.correctmsg) + "\n                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "account-container"
  }, [_c('div', {
    staticClass: "col-main account_center"
  }, [_c('div', {
    staticClass: "account_review_product"
  }, [_c('div', {
    staticStyle: {
      "margin": "4px 0 0"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "min-height": "500px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.pageInitComplete && _vm.productList.length > 0) ? _c('div', [_c('table', {
    staticClass: "product-Reviews"
  }, _vm._l((_vm.productList), function(itemProduct, index) {
    return _c('tr', [_c('td', [_c('div', {
      staticClass: "review_description_left"
    }, [_c('router-link', {
      attrs: {
        "to": '/catalog/product/' + itemProduct.product_id
      }
    }, [_c('img', {
      attrs: {
        "src": itemProduct.imgUrl,
        "width": "75",
        "height": "75"
      }
    })]), _vm._v(" "), _c('a', {
      class: 'review_star review_star_' + itemProduct.rate_star,
      attrs: {
        "external": "",
        "href": "javascript:void(0)"
      }
    })], 1)]), _vm._v(" "), _c('td', [_vm._v("\n                                                " + _vm._s(itemProduct.summary) + "\n                                                "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "review-content"
    }, [_vm._v("\n                                                    " + _vm._s(itemProduct.review_content) + "\n                                                ")]), _vm._v(" "), (itemProduct.status == _vm.noActiveStatus) ? _c('div', {
      staticClass: "review_moderation"
    }, [_vm._v("\n                                                    Your Review is awaiting moderation...\n                                                ")]) : _vm._e(), _vm._v(" "), (itemProduct.status == _vm.refuseStatus) ? _c('div', {
      staticClass: "review_refuse"
    }, [_vm._v("\n                                                    Your Review is refused.\n                                                ")]) : _vm._e(), _vm._v(" "), (itemProduct.status == _vm.activeStatus) ? _c('div', {
      staticClass: "review_accept"
    }, [_vm._v("\n                                                    Your Review is accept.\n                                                ")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "review_date_time"
    }, [_vm._v(_vm._s(itemProduct.review_date))])])])
  }), 0), _vm._v(" "), _c('mugen-scroll', {
    attrs: {
      "handler": _vm.fetchProduct,
      "should-handle": !_vm.loading,
      "scroll-container": "scrollContainer"
    }
  }, [_c('div', {
    staticClass: "infinite-scroll-preloader",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "preloader"
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.pageInitComplete && _vm.productList.length <= 0) ? _c('div', [_vm._v("\n                                    You have submitted no reviews.\n                                ")]) : _vm._e()])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52c1e230!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/customer/Productreview.vue
// module id = 249
// module chunks = 1